module.exports = __webpack_public_path__ + "img/duoyang.62f58f5d.png";